export default __webpack_public_path__ + "static/media/logistic landing.90bc59b5.png";